export const APP_INSTANCE_ENUMS = {
  MOBILE_NFC: 'MobileNFC',
  MOBILE_QRCODE: 'MobileQRCode',
  MOBILE_SDK: 'MobileSdk',
  MOBILE_WEB: 'MobileWeb',
  WEB: 'Web'
};
